import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import DefaultSpinnerComponent from './DefaultSpinnerComponent';
export function defaultGetSpinner(loadingText = 'Loading ...') {
    return _jsx(DefaultSpinnerComponent, { loadingText: loadingText });
}
export const spinnerContext = createContext(defaultGetSpinner);
export const SpinnerProvider = spinnerContext.Provider;
